import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "register-view" }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_3 = { style: {"margin-bottom":"20px"} }
const _hoisted_4 = { key: 1 }

import {computed, Ref, ref, unref} from "vue";
import {UIHandleUpdate} from "@/views/utils";
import UserAPI from "@/api/UserAPI";
import {setAccessToken} from "@/store";
import {ElMessage, FormInstance, FormRules} from "element-plus";
import SMSAPI, {SMSVerificationCodeType} from "@/api/SMSAPI";


export type Form = {
  loginName: string,
  // 密码登录需要
  password: string,
  // 确认密码
  cPassword: string
  // 验证码登录需要
  code: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Register',
  props: {
  redirect: {
    type: String,
    required: false
  }
},
  setup(__props) {

const props = __props




const {redirect = "/"} = props
let form = ref<Form>({
  loginName: "",
  password: "",
  code: "",
  cPassword: "",
})
const formEle = ref<FormInstance | null>(null)

// 规则
const rules = computed(() => {

  let rules: FormRules = {
    loginName: {
      required: true,
      validator: (rule: any, value: any, callback: any) => {
        if (!form.value) return;
        if (!form.value.loginName) {
          callback(new Error("电话没有填写"))
          return;
        }
        if (form.value.loginName.length != 11) {
          callback(new Error("电话号码长度为11位"))
          return
        }
        callback()
      },
      trigger: "blur"
    },
    password: {
      required: true,
      message: "密码没有填写",
      trigger: "blur"
    },
    cPassword: {
      required: true,
      validator: (rule: any, value: any, callback: any) => {
        if (!form.value) return;
        if (!form.value.cPassword) {
          callback(new Error("确认密码没有填写"))
          return;
        }
        if (form.value.cPassword !== form.value.password) {
          callback(new Error("密码不一致"))
          return
        }
        callback()
      },
      trigger: "blur"
    },
    code: {
      required: true,
      message: "验证码没有填写",
      trigger: "blur"
    }
  }

  return rules
})

const {register, loading} = useRegister(form, redirect)
const sendCodeLeftSeconds = ref<number>(0)
const sendCodeLoading = ref<boolean>(false)
const sendCode = async () => {
  formEle.value?.validateField("loginName", async (isValid) => {
    if (isValid) {
      try {
        sendCodeLoading.value = true
        await UIHandleUpdate(SMSAPI.sendVerificationCode({
          tel: form.value.loginName,
          type: SMSVerificationCodeType.REGISTER
        }), "发送验证码成功")

        sendCodeLeftSeconds.value = 60
        let interval = setInterval(() => {
          sendCodeLeftSeconds.value = sendCodeLeftSeconds.value - 1
          if (sendCodeLeftSeconds.value === 0) {
            clearInterval(interval)
          }
        }, 1000)
      } finally {
        sendCodeLoading.value = false
      }
    }
  })
}

function useRegister(formRef: Ref<Form>, redirect: string) {
  const loading = ref(false)
  const register = async () => {

    formEle.value?.validate(async (valid) => {
      if (valid) {
        try {
          loading.value = true
          let form = unref(formRef)

          let result: any

          let data: any = {
            tel: form.loginName,
            password: form.password,
            code: form.code
          }
          result = await UIHandleUpdate(UserAPI.registerByTel(data), "注册成功")

          setAccessToken(result.accessToken, result.id)
          location.reload()

        } catch (e) {
          console.error(e)
        } finally {
          loading.value = false
        }
      }
    })

  }

  return {
    register,
    loading
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          "validate-on-rule-change": false,
          ref_key: "formEle",
          ref: formEle,
          rules: _unref(rules),
          model: _unref(form),
          "label-width": "0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "loginName" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"339px","height":"45px"},
                  placeholder: "请输入手机号",
                  modelValue: _unref(form).loginName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).loginName) = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入密码",
                  style: {"width":"339px","height":"45px"},
                  autocomplete: "new-password",
                  modelValue: _unref(form).password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).password) = $event)),
                  "show-password": "",
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "cPassword" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "再次确认密码",
                  style: {"width":"339px","height":"45px"},
                  autocomplete: "new-password",
                  modelValue: _unref(form).cPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).cPassword) = $event)),
                  "show-password": "",
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "code" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入验证码",
                  style: {"width":"339px","height":"45px"},
                  modelValue: _unref(form).code,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).code) = $event)),
                  size: "large"
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: sendCode,
                      loading: sendCodeLoading.value,
                      size: "small",
                      style: {"width":"120px","font-size":"12px"}
                    }, {
                      default: _withCtx(() => [
                        (sendCodeLeftSeconds.value === 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              style: {"padding-bottom":"2px"},
                              onClick: sendCode
                            }, "获取验证码"))
                          : _createCommentVNode("", true),
                        (sendCodeLeftSeconds.value > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(sendCodeLeftSeconds.value) + "秒", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          style: {"width":"339px","height":"45px"},
          loading: _unref(loading),
          onClick: _unref(register),
          type: "danger"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 注册 ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ])
  ]))
}
}

})